export interface ToggleIndex extends Record<string | number, ToggleItem> {}

export interface ToggleItem {
  id: number | string;
  name: string;
  value: string;
}

export interface ToggleItems {
  operator: string;
  values: ToggleItem[];
}

export interface ItemsCollectionsKeys {
  targetCollectionKey: string;
  fallbackCollectionKey: string;
}

export interface SelectionIndex {
  selectedItems: ToggleIndex;
  unselectedItems: ToggleIndex;
}

export interface Toggleable {
  item: ToggleItem;
  isChecked: boolean;
  disabled: boolean;
  onToggle: (value: boolean) => void;
  showOnly: boolean;
  onClickOnly?: () => void;
}

export enum ItemsIndexKeys {
  ID = 'id',
  NAME = 'name',
  VALUE = 'value',
}
